export default "__VITE_ASSET__DDGZ$rZc__"